/* eslint-disable */
// @ts-nocheck

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteApiAdminCheckinsByGuestIdUsersByLineUserIdData, DeleteApiAdminCheckinsByGuestIdUsersByLineUserIdErrors, DeleteApiAdminCheckinsByGuestIdUsersByLineUserIdResponses, DeleteApiAdminCheckinsByIdData, DeleteApiAdminCheckinsByIdErrors, DeleteApiAdminCheckinsByIdResponses, DeleteApiAdminGuestByIdData, DeleteApiAdminGuestByIdErrors, DeleteApiAdminGuestByIdResponses, DeleteApiRichmenusByIdData, DeleteApiRichmenusByIdErrors, DeleteApiRichmenusByIdResponses, DeleteApiRichmenusDefaultData, DeleteApiRichmenusDefaultErrors, DeleteApiRichmenusDefaultResponses, DeleteApiRichmenusLinkByLineUserIdData, DeleteApiRichmenusLinkByLineUserIdErrors, DeleteApiRichmenusLinkByLineUserIdResponses, DeleteApiTablesMasterByIdData, DeleteApiTablesMasterByIdErrors, DeleteApiTablesMasterByIdResponses, GetApiActivitiesWallData, GetApiActivitiesWallErrors, GetApiActivitiesWallResponses, GetApiAdminCheckinsData, GetApiAdminCheckinsErrors, GetApiAdminCheckinsResponses, GetApiAdminGuestByIdData, GetApiAdminGuestByIdErrors, GetApiAdminGuestByIdResponses, GetApiAdminGuestData, GetApiAdminGuestErrors, GetApiAdminGuestResponses, GetApiAdminUsersData, GetApiAdminUsersErrors, GetApiAdminUsersResponses, GetApiAuthMeData, GetApiAuthMeErrors, GetApiAuthMeResponses, GetApiAuthTokenData, GetApiAuthTokenErrors, GetApiAuthTokenResponses, GetApiGuestsByIdData, GetApiGuestsByIdErrors, GetApiGuestsByIdResponses, GetApiGuestsData, GetApiGuestsErrors, GetApiGuestsGroupsData, GetApiGuestsGroupsErrors, GetApiGuestsGroupsResponses, GetApiGuestsResponses, GetApiRichmenusByIdData, GetApiRichmenusByIdErrors, GetApiRichmenusByIdResponses, GetApiRichmenusData, GetApiRichmenusErrors, GetApiRichmenusResponses, GetApiRichmenusUserByLineUserIdData, GetApiRichmenusUserByLineUserIdErrors, GetApiRichmenusUserByLineUserIdResponses, GetApiSettingsData, GetApiSettingsErrors, GetApiSettingsResponses, GetApiTablesData, GetApiTablesErrors, GetApiTablesGuestByTargetIdData, GetApiTablesGuestByTargetIdErrors, GetApiTablesGuestByTargetIdResponses, GetApiTablesMasterAllData, GetApiTablesMasterAllErrors, GetApiTablesMasterAllResponses, GetApiTablesMasterByIdData, GetApiTablesMasterByIdErrors, GetApiTablesMasterByIdGuestsData, GetApiTablesMasterByIdGuestsErrors, GetApiTablesMasterByIdGuestsResponses, GetApiTablesMasterByIdResponses, GetApiTablesMasterData, GetApiTablesMasterErrors, GetApiTablesMasterResponses, GetApiTablesResponses, PatchApiAdminGuestByIdData, PatchApiAdminGuestByIdErrors, PatchApiAdminGuestByIdResponses, PatchApiAdminUsersByIdData, PatchApiAdminUsersByIdErrors, PatchApiAdminUsersByIdResponses, PatchApiSettingsData, PatchApiSettingsErrors, PatchApiSettingsResponses, PatchApiTablesMasterByIdData, PatchApiTablesMasterByIdErrors, PatchApiTablesMasterByIdResponses, PostApiActivitiesLogBlessingData, PostApiActivitiesLogBlessingErrors, PostApiActivitiesLogBlessingResponses, PostApiActivitiesRandomNumberData, PostApiActivitiesRandomNumberErrors, PostApiActivitiesRandomNumberResponses, PostApiActivitiesSubmitAngpaoData, PostApiActivitiesSubmitAngpaoErrors, PostApiActivitiesSubmitAngpaoResponses, PostApiActivitiesWallBackgroundData, PostApiActivitiesWallBackgroundErrors, PostApiActivitiesWallBackgroundResponses, PostApiActivitiesWallData, PostApiActivitiesWallErrors, PostApiActivitiesWallResponses, PostApiAdminCheckinsManualData, PostApiAdminCheckinsManualErrors, PostApiAdminCheckinsManualResponses, PostApiAdminGuestBulkMapLineIdsData, PostApiAdminGuestBulkMapLineIdsErrors, PostApiAdminGuestBulkMapLineIdsResponses, PostApiAdminGuestData, PostApiAdminGuestErrors, PostApiAdminGuestImportData, PostApiAdminGuestImportErrors, PostApiAdminGuestImportResponses, PostApiAdminGuestResponses, PostApiCheckinsData, PostApiCheckinsErrors, PostApiCheckinsResponses, PostApiRichmenusByIdDefaultData, PostApiRichmenusByIdDefaultErrors, PostApiRichmenusByIdDefaultResponses, PostApiRichmenusByIdImageData, PostApiRichmenusByIdImageErrors, PostApiRichmenusByIdImageResponses, PostApiRichmenusByIdLinkByLineUserIdData, PostApiRichmenusByIdLinkByLineUserIdErrors, PostApiRichmenusByIdLinkByLineUserIdResponses, PostApiRichmenusData, PostApiRichmenusErrors, PostApiRichmenusResponses, PostApiRichmenusSyncAllData, PostApiRichmenusSyncAllErrors, PostApiRichmenusSyncAllResponses, PostApiTablesBulkData, PostApiTablesBulkErrors, PostApiTablesBulkResponses, PostApiTablesData, PostApiTablesErrors, PostApiTablesMasterData, PostApiTablesMasterErrors, PostApiTablesMasterImportData, PostApiTablesMasterImportErrors, PostApiTablesMasterImportResponses, PostApiTablesMasterResponses, PostApiTablesResponses, PostApiTablesUnassignData, PostApiTablesUnassignErrors, PostApiTablesUnassignResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Create a new check-in record
 */
export const postApiCheckins = <ThrowOnError extends boolean = true>(options?: Options<PostApiCheckinsData, ThrowOnError>) => (options?.client ?? client).post<PostApiCheckinsResponses, PostApiCheckinsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/checkins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List all master tables
 */
export const getApiTablesMaster = <ThrowOnError extends boolean = true>(options?: Options<GetApiTablesMasterData, ThrowOnError>) => (options?.client ?? client).get<GetApiTablesMasterResponses, GetApiTablesMasterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tables/master',
    ...options
});

/**
 * Create a new master table
 */
export const postApiTablesMaster = <ThrowOnError extends boolean = true>(options?: Options<PostApiTablesMasterData, ThrowOnError>) => (options?.client ?? client).post<PostApiTablesMasterResponses, PostApiTablesMasterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tables/master',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete a master table
 */
export const deleteApiTablesMasterById = <ThrowOnError extends boolean = true>(options: Options<DeleteApiTablesMasterByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiTablesMasterByIdResponses, DeleteApiTablesMasterByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tables/master/{id}',
    ...options
});

/**
 * Get master table details
 */
export const getApiTablesMasterById = <ThrowOnError extends boolean = true>(options: Options<GetApiTablesMasterByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiTablesMasterByIdResponses, GetApiTablesMasterByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tables/master/{id}',
    ...options
});

/**
 * Update master table metadata
 */
export const patchApiTablesMasterById = <ThrowOnError extends boolean = true>(options: Options<PatchApiTablesMasterByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiTablesMasterByIdResponses, PatchApiTablesMasterByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tables/master/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all master tables (no pagination)
 */
export const getApiTablesMasterAll = <ThrowOnError extends boolean = true>(options?: Options<GetApiTablesMasterAllData, ThrowOnError>) => (options?.client ?? client).get<GetApiTablesMasterAllResponses, GetApiTablesMasterAllErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tables/master/all',
    ...options
});

/**
 * Import master tables from CSV
 */
export const postApiTablesMasterImport = <ThrowOnError extends boolean = true>(options?: Options<PostApiTablesMasterImportData, ThrowOnError>) => (options?.client ?? client).post<PostApiTablesMasterImportResponses, PostApiTablesMasterImportErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tables/master/import',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * List all table assignments
 */
export const getApiTables = <ThrowOnError extends boolean = true>(options?: Options<GetApiTablesData, ThrowOnError>) => (options?.client ?? client).get<GetApiTablesResponses, GetApiTablesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tables',
    ...options
});

/**
 * Assign a table to a guest
 */
export const postApiTables = <ThrowOnError extends boolean = true>(options?: Options<PostApiTablesData, ThrowOnError>) => (options?.client ?? client).post<PostApiTablesResponses, PostApiTablesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tables',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Unassign/remove a table from a guest
 */
export const postApiTablesUnassign = <ThrowOnError extends boolean = true>(options?: Options<PostApiTablesUnassignData, ThrowOnError>) => (options?.client ?? client).post<PostApiTablesUnassignResponses, PostApiTablesUnassignErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tables/unassign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Assign multiple guest groups to a table
 */
export const postApiTablesBulk = <ThrowOnError extends boolean = true>(options?: Options<PostApiTablesBulkData, ThrowOnError>) => (options?.client ?? client).post<PostApiTablesBulkResponses, PostApiTablesBulkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tables/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get table assignment for a guest
 */
export const getApiTablesGuestByTargetId = <ThrowOnError extends boolean = true>(options?: Options<GetApiTablesGuestByTargetIdData, ThrowOnError>) => (options?.client ?? client).get<GetApiTablesGuestByTargetIdResponses, GetApiTablesGuestByTargetIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tables/guest/{targetId}',
    ...options
});

/**
 * List guests for a table
 */
export const getApiTablesMasterByIdGuests = <ThrowOnError extends boolean = true>(options: Options<GetApiTablesMasterByIdGuestsData, ThrowOnError>) => (options.client ?? client).get<GetApiTablesMasterByIdGuestsResponses, GetApiTablesMasterByIdGuestsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/tables/master/{id}/guests',
    ...options
});

/**
 * List all guests in the master list
 */
export const getApiGuests = <ThrowOnError extends boolean = true>(options?: Options<GetApiGuestsData, ThrowOnError>) => (options?.client ?? client).get<GetApiGuestsResponses, GetApiGuestsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/guests',
    ...options
});

/**
 * Get all unique guest groups
 */
export const getApiGuestsGroups = <ThrowOnError extends boolean = true>(options?: Options<GetApiGuestsGroupsData, ThrowOnError>) => (options?.client ?? client).get<GetApiGuestsGroupsResponses, GetApiGuestsGroupsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/guests/groups',
    ...options
});

/**
 * Get guest details
 */
export const getApiGuestsById = <ThrowOnError extends boolean = true>(options: Options<GetApiGuestsByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiGuestsByIdResponses, GetApiGuestsByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/guests/{id}',
    ...options
});

/**
 * Get Firebase custom token for the authenticated user
 */
export const getApiAuthToken = <ThrowOnError extends boolean = true>(options?: Options<GetApiAuthTokenData, ThrowOnError>) => (options?.client ?? client).get<GetApiAuthTokenResponses, GetApiAuthTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/auth/token',
    ...options
});

/**
 * Get current user status and profile
 */
export const getApiAuthMe = <ThrowOnError extends boolean = true>(options?: Options<GetApiAuthMeData, ThrowOnError>) => (options?.client ?? client).get<GetApiAuthMeResponses, GetApiAuthMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/auth/me',
    ...options
});

/**
 * Log a wedding blessing
 */
export const postApiActivitiesLogBlessing = <ThrowOnError extends boolean = true>(options: Options<PostApiActivitiesLogBlessingData, ThrowOnError>) => (options.client ?? client).post<PostApiActivitiesLogBlessingResponses, PostApiActivitiesLogBlessingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/activities/log-blessing',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit a wedding e-angpao slip
 */
export const postApiActivitiesSubmitAngpao = <ThrowOnError extends boolean = true>(options: Options<PostApiActivitiesSubmitAngpaoData, ThrowOnError>) => (options.client ?? client).post<PostApiActivitiesSubmitAngpaoResponses, PostApiActivitiesSubmitAngpaoErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/activities/submit-angpao',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Submit a random number for Lucky Draw
 */
export const postApiActivitiesRandomNumber = <ThrowOnError extends boolean = true>(options: Options<PostApiActivitiesRandomNumberData, ThrowOnError>) => (options.client ?? client).post<PostApiActivitiesRandomNumberResponses, PostApiActivitiesRandomNumberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/activities/random-number',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload a custom wall background image
 */
export const postApiActivitiesWallBackground = <ThrowOnError extends boolean = true>(options: Options<PostApiActivitiesWallBackgroundData, ThrowOnError>) => (options.client ?? client).post<PostApiActivitiesWallBackgroundResponses, PostApiActivitiesWallBackgroundErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/activities/wall/background',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get the current wall settings, sessions, and winners
 */
export const getApiActivitiesWall = <ThrowOnError extends boolean = true>(options?: Options<GetApiActivitiesWallData, ThrowOnError>) => (options?.client ?? client).get<GetApiActivitiesWallResponses, GetApiActivitiesWallErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/activities/wall',
    ...options
});

/**
 * Update the wall settings, sessions, and winners
 */
export const postApiActivitiesWall = <ThrowOnError extends boolean = true>(options: Options<PostApiActivitiesWallData, ThrowOnError>) => (options.client ?? client).post<PostApiActivitiesWallResponses, PostApiActivitiesWallErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/activities/wall',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get global wedding settings
 */
export const getApiSettings = <ThrowOnError extends boolean = true>(options?: Options<GetApiSettingsData, ThrowOnError>) => (options?.client ?? client).get<GetApiSettingsResponses, GetApiSettingsErrors, ThrowOnError>({ url: '/api/settings', ...options });

/**
 * Update global wedding settings
 */
export const patchApiSettings = <ThrowOnError extends boolean = true>(options: Options<PatchApiSettingsData, ThrowOnError>) => (options.client ?? client).patch<PatchApiSettingsResponses, PatchApiSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: List all LINE rich menus
 */
export const getApiRichmenus = <ThrowOnError extends boolean = true>(options?: Options<GetApiRichmenusData, ThrowOnError>) => (options?.client ?? client).get<GetApiRichmenusResponses, GetApiRichmenusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/richmenus',
    ...options
});

/**
 * Admin: Create a new LINE rich menu configuration
 */
export const postApiRichmenus = <ThrowOnError extends boolean = true>(options: Options<PostApiRichmenusData, ThrowOnError>) => (options.client ?? client).post<PostApiRichmenusResponses, PostApiRichmenusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/richmenus',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: Delete a LINE rich menu
 */
export const deleteApiRichmenusById = <ThrowOnError extends boolean = true>(options: Options<DeleteApiRichmenusByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiRichmenusByIdResponses, DeleteApiRichmenusByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/richmenus/{id}',
    ...options
});

/**
 * Admin: Get details of a LINE rich menu
 */
export const getApiRichmenusById = <ThrowOnError extends boolean = true>(options: Options<GetApiRichmenusByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiRichmenusByIdResponses, GetApiRichmenusByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/richmenus/{id}',
    ...options
});

/**
 * Admin: Cancel global default LINE rich menu
 */
export const deleteApiRichmenusDefault = <ThrowOnError extends boolean = true>(options?: Options<DeleteApiRichmenusDefaultData, ThrowOnError>) => (options?.client ?? client).delete<DeleteApiRichmenusDefaultResponses, DeleteApiRichmenusDefaultErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/richmenus/default',
    ...options
});

/**
 * Admin: Upload background image for a LINE rich menu
 */
export const postApiRichmenusByIdImage = <ThrowOnError extends boolean = true>(options: Options<PostApiRichmenusByIdImageData, ThrowOnError>) => (options.client ?? client).post<PostApiRichmenusByIdImageResponses, PostApiRichmenusByIdImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/richmenus/{id}/image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Admin: Set global default LINE rich menu
 */
export const postApiRichmenusByIdDefault = <ThrowOnError extends boolean = true>(options: Options<PostApiRichmenusByIdDefaultData, ThrowOnError>) => (options.client ?? client).post<PostApiRichmenusByIdDefaultResponses, PostApiRichmenusByIdDefaultErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/richmenus/{id}/default',
    ...options
});

/**
 * Admin: Link a LINE rich menu to a specific user
 */
export const postApiRichmenusByIdLinkByLineUserId = <ThrowOnError extends boolean = true>(options: Options<PostApiRichmenusByIdLinkByLineUserIdData, ThrowOnError>) => (options.client ?? client).post<PostApiRichmenusByIdLinkByLineUserIdResponses, PostApiRichmenusByIdLinkByLineUserIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/richmenus/{id}/link/{lineUserId}',
    ...options
});

/**
 * Admin: Unlink any personalized LINE rich menu from a specific user
 */
export const deleteApiRichmenusLinkByLineUserId = <ThrowOnError extends boolean = true>(options: Options<DeleteApiRichmenusLinkByLineUserIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiRichmenusLinkByLineUserIdResponses, DeleteApiRichmenusLinkByLineUserIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/richmenus/link/{lineUserId}',
    ...options
});

/**
 * Admin: Get bound LINE rich menu ID for a specific user
 */
export const getApiRichmenusUserByLineUserId = <ThrowOnError extends boolean = true>(options: Options<GetApiRichmenusUserByLineUserIdData, ThrowOnError>) => (options.client ?? client).get<GetApiRichmenusUserByLineUserIdResponses, GetApiRichmenusUserByLineUserIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/richmenus/user/{lineUserId}',
    ...options
});

/**
 * Admin: Sync conditional rich menus for all users
 */
export const postApiRichmenusSyncAll = <ThrowOnError extends boolean = true>(options?: Options<PostApiRichmenusSyncAllData, ThrowOnError>) => (options?.client ?? client).post<PostApiRichmenusSyncAllResponses, PostApiRichmenusSyncAllErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/richmenus/sync-all',
    ...options
});

/**
 * Admin: List all guests in the master list with full details
 */
export const getApiAdminGuest = <ThrowOnError extends boolean = true>(options?: Options<GetApiAdminGuestData, ThrowOnError>) => (options?.client ?? client).get<GetApiAdminGuestResponses, GetApiAdminGuestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/guest',
    ...options
});

/**
 * Create a new guest in the master list
 */
export const postApiAdminGuest = <ThrowOnError extends boolean = true>(options?: Options<PostApiAdminGuestData, ThrowOnError>) => (options?.client ?? client).post<PostApiAdminGuestResponses, PostApiAdminGuestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/guest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete a guest from the master list
 */
export const deleteApiAdminGuestById = <ThrowOnError extends boolean = true>(options: Options<DeleteApiAdminGuestByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiAdminGuestByIdResponses, DeleteApiAdminGuestByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/guest/{id}',
    ...options
});

/**
 * Admin: Get guest details with full details
 */
export const getApiAdminGuestById = <ThrowOnError extends boolean = true>(options: Options<GetApiAdminGuestByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiAdminGuestByIdResponses, GetApiAdminGuestByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/guest/{id}',
    ...options
});

/**
 * Update guest details
 */
export const patchApiAdminGuestById = <ThrowOnError extends boolean = true>(options: Options<PatchApiAdminGuestByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiAdminGuestByIdResponses, PatchApiAdminGuestByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/guest/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Import guests from CSV
 */
export const postApiAdminGuestImport = <ThrowOnError extends boolean = true>(options?: Options<PostApiAdminGuestImportData, ThrowOnError>) => (options?.client ?? client).post<PostApiAdminGuestImportResponses, PostApiAdminGuestImportErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/guest/import',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Bulk map LINE User IDs and metadata to guests
 */
export const postApiAdminGuestBulkMapLineIds = <ThrowOnError extends boolean = true>(options?: Options<PostApiAdminGuestBulkMapLineIdsData, ThrowOnError>) => (options?.client ?? client).post<PostApiAdminGuestBulkMapLineIdsResponses, PostApiAdminGuestBulkMapLineIdsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/guest/bulk-map-line-ids',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List all users (for admin management)
 */
export const getApiAdminUsers = <ThrowOnError extends boolean = true>(options?: Options<GetApiAdminUsersData, ThrowOnError>) => (options?.client ?? client).get<GetApiAdminUsersResponses, GetApiAdminUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users',
    ...options
});

/**
 * Update user admin role and module access
 */
export const patchApiAdminUsersById = <ThrowOnError extends boolean = true>(options: Options<PatchApiAdminUsersByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiAdminUsersByIdResponses, PatchApiAdminUsersByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: List all check-ins
 */
export const getApiAdminCheckins = <ThrowOnError extends boolean = true>(options?: Options<GetApiAdminCheckinsData, ThrowOnError>) => (options?.client ?? client).get<GetApiAdminCheckinsResponses, GetApiAdminCheckinsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/checkins',
    ...options
});

/**
 * Admin: Create a manual check-in record (guest without LINE)
 */
export const postApiAdminCheckinsManual = <ThrowOnError extends boolean = true>(options: Options<PostApiAdminCheckinsManualData, ThrowOnError>) => (options.client ?? client).post<PostApiAdminCheckinsManualResponses, PostApiAdminCheckinsManualErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/checkins/manual',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: Delete a check-in record
 */
export const deleteApiAdminCheckinsById = <ThrowOnError extends boolean = true>(options: Options<DeleteApiAdminCheckinsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiAdminCheckinsByIdResponses, DeleteApiAdminCheckinsByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/checkins/{id}',
    ...options
});

/**
 * Admin: Remove a specific LINE user from a guest party check-in
 */
export const deleteApiAdminCheckinsByGuestIdUsersByLineUserId = <ThrowOnError extends boolean = true>(options: Options<DeleteApiAdminCheckinsByGuestIdUsersByLineUserIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiAdminCheckinsByGuestIdUsersByLineUserIdResponses, DeleteApiAdminCheckinsByGuestIdUsersByLineUserIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/checkins/{guestId}/users/{lineUserId}',
    ...options
});
